namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class FormMultiCustomEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
        }
        getSelect2Options() {
            let hasil = super.getSelect2Options();
            hasil.multiple = true;
            return hasil;
        }
        get_delimited() {
            return true;
        }
        isMultiple() {
            return true;
        }
        setOpt(data: any) {
            data.forEach(fy => {
                this.addItem({
                    id: fy.id,
                    text: fy.name
                });
            })
        }
    }
}